import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import classnames from 'classnames';
import { toastr } from 'react-redux-toastr';
import { useTranslation } from 'react-i18next';

import CustomButton from '../../../CustomButton';

import { passwordValidation } from '../../../helpers/helperAccount';
import { changeUserPasswordOld, logoutUser } from '../../../../action/AccountActions';
import { useAuth } from "../../../../../../context/AuthContext";

const CreatePasswordForm = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { logout } = useAuth();

    const { t, i18n } = useTranslation('translation', { keyPrefix: 'loginForms.resetPasswordForm' });

    const [data, setData] = useState({
        new_password: '',
        new_password_confirm: '',
    })
    const [errMessage, setErrMessage] = useState({
        new_password: '',
        new_password_confirm: '',
    })
    const [toggle_password, setToggle_password] = useState(true);
    const [toggle_password_confirm, setToggle_password_confirm] = useState(true);
    const [disabledSave, setDisabledSave] = useState(true);

    const toggleLoader = useCallback((show) => {
        dispatch({ type: 'TOGGLE_LOADER', payload: show });
    }, [dispatch]);

    const togglePassword = () => {
        setToggle_password(!toggle_password);
    }

    const togglePassword2 = () => {
        setToggle_password_confirm(!toggle_password_confirm);
    }

    const handleInputChange = (e) => {
        const newData = { ...data, [e.target.name]: e.target.value };
        setData(newData);

        (!data.new_password && !data.new_password_confirm) ? setDisabledSave(true) : setDisabledSave(checkForm(newData));
    }

    const checkForm = (data) => {
        let error = false;
        const updatedErrMessage = { ...errMessage };

        for (let i in data) {
            if (data[i] == '') {
                error = true;
                updatedErrMessage[i] = t('enterPassword');
            } else if (updatedErrMessage[i]) {
                updatedErrMessage[i] = null;
            }
        }

        if (!updatedErrMessage.new_password) {
            const validation = passwordValidation(data.new_password)
            if (!validation.result) {
                error = true;
                updatedErrMessage.new_password = validation.error;
            }
            else if (data.new_password !== data.new_password_confirm) {
                error = true;
                updatedErrMessage.new_password = t('errPasswords');
            }
        }

        if (!updatedErrMessage.new_password_confirm) {
            if (data.new_password !== data.new_password_confirm) {
                error = true;
                updatedErrMessage.new_password_confirm = t('errPasswords');
            }
        }

        setErrMessage(updatedErrMessage);
        return error;
    }

    const sendForm = async (e) => {
        e.preventDefault()

        const queryParams = new URLSearchParams(location.search);
        const params = {
            token: queryParams.get('token'),
            new_password: data.new_password,
            new_password_confirm: data.new_password_confirm
        }
        const error = checkForm(params);
        if (error) {
            return;
        }
        toggleLoader(true);
        try {
            const changePasswordResult = await changeUserPasswordOld(params);
            const errorMsg = changePasswordResult?.data?.response?.error;

            if (errorMsg === 'you have to logout first') {
                try {
                    await logoutUser();
                    await logout();
                    return sendForm(e);
                } catch (logoutError) {
                    console.error('Logout error:', logoutError);
                }
            } else {
                navigate('/login');
            }
        } catch (changePasswordError) {
            console.log('changePasswordError: ', changePasswordError)
            toastr.error('', changePasswordError.response?.data?.response?.error || i18n.t('errorMessage.errDescription'));
        } finally {
            toggleLoader(false);
        }
    }

    const { new_password, new_password_confirm } = errMessage;

    return (
        <>
            <div className="panel-body">
                <h3 className='login-header'>{`${t('headerCreate')} ${t('headerPassword')}`}</h3>
                <div className="form-wrapper">
                    <form autoComplete="off" onSubmit={sendForm}>
                        <div className={classnames('login-form form-group has-feedback', { 'error': new_password })}
                             style={{ maxHeight: '54px' }}>
                            <input
                                type={toggle_password ? "password" : "text"}
                                name="new_password"
                                autoComplete="off"
                                className={`vehicle-search ${new_password ? 'error' : ''}`}
                                placeholder={t('placeholderNewPassword')}
                                onChange={handleInputChange}
                            />
                            <span className="fa fa-eye form-control-feedback" onClick={togglePassword}></span>
                            {new_password && <span className="help-block error-label">{new_password}</span>}
                        </div>
                        <div className={classnames('login-form form-group has-feedback', { 'error': new_password_confirm })}
                             style={{ maxHeight: '54px' }}>
                            <input
                                type={toggle_password_confirm ? "password" : "text"}
                                name="new_password_confirm"
                                autoComplete="off"
                                className={`vehicle-search ${new_password_confirm ? 'error' : ''}`}
                                placeholder={`${t('placeholderRe-enterNew')} ${t('placeholderPassword')}`}
                                onChange={handleInputChange}
                            />
                            <span className="fa fa-eye form-control-feedback" onClick={togglePassword2}></span>
                            {new_password_confirm && <span className="help-block error-label">{new_password_confirm}</span>}
                        </div>
                        <div className="change-password-submit form-group submit-btn" style={{ marginTop: '40px' }}>
                            <CustomButton variant="primary" size="lg" value="Submit" type="submit" id="restore-button"
                                          disabled={disabledSave}>
                                {t('btnSavePassword')}
                            </CustomButton>
                        </div>
                    </form>
                </div>
            </div>
            <div className="panel-body contact-section">
                <h5>{t('titlePasswordMustHave')}</h5>
                <div className="login-subheader" style={{ marginTop: 0 }}>
                    <ul>
                        <li>{t('text_5')}</li>
                        <li>{t('text_6')}</li>
                        <li>{t('text_7')}</li>
                        <li>{t('text_8')}</li>
                        <li>{t('text_9')}</li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default CreatePasswordForm;
